import { useMemo } from 'react';
import { calculateFooter } from './useFooterCalculation';
import { GROUPBY } from '../../../../constants/Reports';

export const useOvertimeRows = (raw, columns, groupby) =>
  useMemo(() => {
    const source = (raw && raw.data) || raw;
    if (!source || typeof source !== 'object') return [];

    return Object.entries(source).map(([groupTitle, rows]) => {
      const items = (rows || []).map((arrRow, rowIndex) => {
        if (groupby === GROUPBY[0].value) {
          const [date, shift, hours] = arrRow;
          return { id: rowIndex, date, shift, hours };
        }
        if (groupby === GROUPBY[1].value) {
          const [employee, shift, hours] = arrRow;
          return { id: rowIndex, employee, shift, hours };
        }

        const rowObject = { id: rowIndex };
        (arrRow || []).forEach((value, i) => {
          rowObject[`col${i}`] = value;
        });
        return rowObject;
      });

      const footer = calculateFooter(items, columns);

      return {
        name: groupTitle,
        items,
        footer,
      };
    });
  }, [raw, columns, groupby]);
